import { useMutation, useQuery } from "@apollo/client";
import {
    GET_UPCOMING_INVOICE,
    SUBSCRIBE_PLAN,
    UNSUBSCRIBE_PLAN,
} from "gql/billing.gql";
import { GetUpcomingInvoice } from "gql/types/GetUpcomingInvoice";
import { SubscribePlan, SubscribePlanVariables } from "gql/types/SubscribePlan";
import { UnsubscribePlan } from "gql/types/UnsubscribePlan";

import { CustomMutationHook, CustomQueryHook } from "../graphql.hook.type";
import {
    UseUpcomingInvoiceResult,
    UseSubscribePlanResult,
    UseUnsubscribePlanResult,
} from "./billing.hook.types";

export const useUpcomingInvoice: CustomQueryHook<
    { userEmailID?: string },
    UseUpcomingInvoiceResult
> = ({ userEmailID }: { userEmailID?: string }) => {
    const useQueryResult = useQuery<GetUpcomingInvoice>(GET_UPCOMING_INVOICE, {
        variables: { userEmailID },
        fetchPolicy: "network-only",
    });
    return {
        ...useQueryResult,
        invoice: useQueryResult.data?.getUpcomingInvoice
            ? {
                  ...useQueryResult.data.getUpcomingInvoice,
                  amountDue:
                      useQueryResult.data.getUpcomingInvoice.amountDue / 100,
                  amountRemaining:
                      useQueryResult.data.getUpcomingInvoice.amountRemaining /
                      100,
              }
            : null,
    };
};

export const useSubscribePlan: CustomMutationHook<
    void,
    UseSubscribePlanResult
> = () => {
    const [subscribe, mutationResult] = useMutation<
        SubscribePlan,
        SubscribePlanVariables
    >(SUBSCRIBE_PLAN);
    return {
        ...mutationResult,
        subscribe: (sourceID: string) => {
            return subscribe({
                variables: {
                    sourceID,
                },
            });
        },
    };
};

export const useUnsubscribePlan: CustomMutationHook<
    void,
    UseUnsubscribePlanResult
> = () => {
    const [unsubscribe, mutationResult] = useMutation<UnsubscribePlan>(
        UNSUBSCRIBE_PLAN
    );
    return {
        ...mutationResult,
        unsubscribe,
    };
};
